// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MHGB","left":"styles_left__2zjb4","right":"styles_right__2VNre","alert":"styles_alert__1cZzh"};